import { Form, FormSaveButton } from '@ztechapps/webui.form'
import React from 'react'
import type { SaveCancelButtonsProps } from '@ztechapps/webui.button'
import { Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'
import type { ProjectAddComponent } from '@ztechapps/project.webui'
import { ProjectAddProvider, useProjectAddContext } from '@ztechapps/project.webui'

const ProjectFormSave = (_props: SaveCancelButtonsProps) => <FormSaveButton text="Create" />
const components = {
  saveCancelButtons: ProjectFormSave,
} as ProjectAddComponent
export const AddProject = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  return (
    <ProjectAddProvider components={components}>
      <Layout onCloseMenu={onCloseMenu} />
    </ProjectAddProvider>
  )
}

export const Layout = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  const { initialValues, validate, onSubmit, onReset, components } = useProjectAddContext()

  const onSubmitCore = async (args) => {
    await onSubmit(args)
    onCloseMenu()
  }

  return (
    <Form initialValues={initialValues} validate={validate} onSubmit={onSubmitCore} onReset={onReset}>
      <Stack gap={2}>
        <components.formInput />
        <HorizontalStack className="justify-content-end">
          <div>
            <components.saveCancelButtons />
          </div>
        </HorizontalStack>
      </Stack>
    </Form>
  )
}
